export const BUILD_VERSION = {
  "buildNumber": 117,
  "buildDate": "2026_06_24",
  "version": "00117/2026_06_24",
  "releaseVersion": "v1.0.4"
};